import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Delete = createReactComponent("Delete", ["svg", defaultAttributes, [["path", {
  d: "M21 4H8l-7 8 7 8h13a2 2 0 002-2V6a2 2 0 00-2-2z",
  key: "76eywn"
}], ["line", {
  x1: "18",
  y1: "9",
  x2: "12",
  y2: "15",
  key: "1f8sgm"
}], ["line", {
  x1: "12",
  y1: "9",
  x2: "18",
  y2: "15",
  key: "qf4fdz"
}]]]);
export default Delete;